module.exports = __webpack_public_path__ + "static/media/SuddenlyaMurder.71f2fbbe.jpg";